"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _uiKit = require("@devsta/ui-kit");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var AddUserToTeam = function AddUserToTeam(props) {
  var hasManagePermission = props.hasManagePermission,
      userFound = props.userFound,
      onSelectTeamRole = props.onSelectTeamRole,
      onUserAdd = props.onUserAdd,
      teamRoleOptions = props.teamRoleOptions,
      onClose = props.onClose;

  if (!hasManagePermission) {
    return null;
  }

  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, userFound ? /*#__PURE__*/_react.default.createElement("div", {
    className: "assign-user__role-select"
  }, /*#__PURE__*/_react.default.createElement(_uiKit.Dropdown, {
    id: "team-type",
    className: "assign-user__role-select__dropdown",
    onChange: onSelectTeamRole,
    defaultValue: userFound.role,
    options: teamRoleOptions,
    fontSize: 14,
    disabled: !hasManagePermission
  }), /*#__PURE__*/_react.default.createElement(_uiKit.Icon, {
    name: "close",
    size: 12,
    color: "regent",
    onClick: onClose
  })) : /*#__PURE__*/_react.default.createElement(_uiKit.Button, {
    small: true,
    onClick: onUserAdd
  }, "Add To Team"));
};

var _default = AddUserToTeam;
exports.default = _default;